module.exports = __webpack_public_path__ + "img/startIcon.0fe7d492.png";